"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardOverlay = BoardOverlay;
const React = __importStar(require("react"));
const useStyles_1 = require("~/useStyles");
const useStyles = (0, useStyles_1.createUseThemeStyles)((theme) => ({
    overlay: {
        position: "absolute",
        top: "0",
        left: "0",
        zIndex: "500",
        display: "flex",
        width: "100%",
        height: "100%",
        justifyContent: "space-around",
        alignItems: "center",
        inset: "0",
        background: "rgba(0, 0, 0, 0.85)",
    },
    content: {
        "position": "absolute",
        "overflow": "auto",
        "boxSizing": "border-box",
        "display": "flex",
        "height": "80%",
        "width": "80%",
        "padding": "8px",
        "outline": "none",
        "fontFamily": theme.typography.primary,
        "color": "#fff",
        "background": "#333c57",
        "@media (orientation: portrait) and (min-width: 400px) and (max-width: 430px)": {
            width: "96%",
            height: "96%",
        },
        "@media (orientation: portrait) and (max-width: 399px )": {
            width: "100%",
            height: "100%",
        },
    },
}));
function BoardOverlay({ children }) {
    const styles = useStyles();
    return (React.createElement("div", { className: styles.overlay },
        React.createElement("div", { className: styles.content },
            " ",
            children)));
}
